import o from "./common.json.js";
const m = {
  common: o
};
export {
  m as default
};
